// Greys the main tab bar fades through, from the first tab to the last one.
const RAMP_LIGHTEST = 0xE3;
const RAMP_DARKEST = 0x2C;

// Below this relative luminance, white text contrasts better than black.
const DARK_TEXT_LUMINANCE_LIMIT = 0.179;

const hex = value => value.toString(16).padStart(2, '0');

// https://www.w3.org/TR/WCAG21/#dfn-relative-luminance, for a grey (r === g === b).
const greyLuminance = (grey) => {
  const channel = grey / 255;
  return channel <= 0.03928 ? channel / 12.92 : ((channel + 0.055) / 1.055) ** 2.4;
};

// Spreads the ramp over however many tabs there are, so adding or removing one
// keeps the first tab light, the last one dark and every step in between even.
const tabShade = (index, total) => {
  const steps = Math.max(total - 1, 1);
  const position = Math.min(Math.max(index, 0), steps) / steps;
  const grey = Math.round(RAMP_LIGHTEST + ((RAMP_DARKEST - RAMP_LIGHTEST) * position));

  return {
    backgroundColor: `#${hex(grey).repeat(3)}`,
    color: greyLuminance(grey) < DARK_TEXT_LUMINANCE_LIMIT ? '#fff' : '#000',
  };
};

export default tabShade;
